﻿import type {Ref} from "vue";

import {useAccessToken} from "./useAccessToken";
import {useMateApi} from "./useMateApi";
import {computed} from "vue";
import {useScopeSources} from "./useScopeSources";


export interface ShoppingCartDocumentHeader {
    TenantOid: number;
    LocationRoleOid: number;
    LocationID: string;
    Usage: ShoppingCartUsage;
    IsDropShipment: boolean;
    AutoGenerateIntermediateTotal: boolean;
    Message: string;
    Customer: ShoppingCartCustomerModel;
}

export interface ShoppingCartCustomerModel {
    Number: string;
    FirstName: string;
    LastName: string;
    Street: string;
    Location: string;
    EmailAddress: string;
    PhoneNumber: string;
    MobileNumber: string;
    //DateOfBirth: Nullable<Date>;
}

export interface ShoppingCartTaxModel {
    Name: string;
    Code: string;
    Rate: number;
}

export enum ShoppingCartUsage {
    NotDefined = "NON",
    Payment = "PAY",
    ReservationDemand = "RDM",
    Notification = "NFY",
}
export enum ShoppingCartItemUsage {
    Merchandise = "MERC",
    Reference = "AREF",
    GiftCard = "PGCA",
    NonFiscal = "NONF",
}

export enum ShoppingCartItemDocumentType {
    SalesReceipt = "SLS",
    CustomerOrder = "COR",
    CustomerOffer = "COF",
    Reservation = "RSV",
    CustomerLoan = "LOA",
}

export interface ShoppingCartItemModel {
    Usage: ShoppingCartItemUsage;
    NextProcessingDocument: ShoppingCartItemDocumentType;
    InternalNumber: string;
    Gtin: string;
    Text: string;
    Description: string;

    Size: string;
    Color: string;
    Material: string;
    ProductGroup: string;

    Quantity: number;
    RetailPriceGross: number;
    IsRetoure: boolean;

    SerialNumber: string;
    CouponNumber: string;
    TransactionNumber: string;
    Tax: ShoppingCartTaxModel;

    // calculated
    Total: number;
}

export interface ShoppingCartModel {
    LocationID: string;
    Usage: ShoppingCartUsage;
    IsDropShipment: boolean;
    AutoGenerateIntermediateTotal: boolean;
    Message: string;
    Customer?: ShoppingCartCustomerModel
    Items: ShoppingCartItemModel[];
}


export const useShoppingCartApi = (header: Ref<ShoppingCartDocumentHeader>) => {

    const {accessToken} = useAccessToken();
    const {getTenant} = useScopeSources();
    const tenantOid = computed(() => header.value.TenantOid);
    const tenantId = computed(() => getTenant(tenantOid.value)?.id);
    
    const {jsonEndpoint, xmlEndpoint} = useMateApi(accessToken, tenantOid);
    const baseUrl = "/api/v1-pub";
    const jsonApi = jsonEndpoint(baseUrl);
    const xmlApi = xmlEndpoint(baseUrl);
    
    const getRandomItem = () => jsonApi.get<ShoppingCartItemModel>({withAbsoluteQuantity: true}, {url: `/${tenantId.value}/shopping-cart/item/random`});
    const createShoppingCart = (items: ShoppingCartItemModel[]) =>
        xmlApi.post(<ShoppingCartModel>{
            LocationID: header.value.LocationID,
            Usage: header.value.Usage,
            AutoGenerateIntermediateTotal: header.value.AutoGenerateIntermediateTotal,
            IsDropShipment: header.value.IsDropShipment,
            Message: header.value.Message,
            Customer: JSON.stringify(header.value.Customer) !== "{}" && header.value.Customer.Number 
                ? header.value.Customer
                : undefined,
            Items: items
        }, {}, {
            url: `/${tenantId.value}/shopping-cart`,
            headers: {"Content-Type": "application/json; charset=UTF-8"}
        });

    return {
        getRandomItem,
        createShoppingCart
    }
}
